import { Injectable } from '@angular/core';
import { BaseChainBaseGuard } from '../../internal';
import { UserEntityModels } from '@medsurf/flat-models';
import { delay, first, lastValueFrom } from 'rxjs';
import * as FlatModels from '@medsurf/flat-models';

@Injectable({
  providedIn: 'root'
})
export class UserAuthorGuard extends BaseChainBaseGuard {
  override async canActivate(): Promise<boolean> {
    let user = this.baseChainGuardFacade.snapshot_user();

    if (!user) {
      this.baseChainGuardFacade.requestMe();
      await lastValueFrom(this.baseChainGuardFacade.ofActionDispatchedMeSuccess.pipe(first(), delay(1)));
      user = this.baseChainGuardFacade.snapshot_user();
    }

    if (user) {
      if (UserEntityModels.canAccessAuthor(user)) {
        return true;
      }

      // No access rights for author
      this.baseChainGuardFacade.requestAddAlert({
        key: 'main',
        detail: 'notification.no_access_rights_for_author',
        severity: FlatModels.AlertControlModels.AlertType.enum.error,
        life: FlatModels.AlertControlModels.AlertTime.DEFAULT
      });
    } else {
      // No Session
      this.baseChainGuardFacade.requestAddAlert({
        key: 'main',
        detail: 'notification.session_invalid',
        severity: FlatModels.AlertControlModels.AlertType.enum.error,
        life: FlatModels.AlertControlModels.AlertTime.DEFAULT
      });
    }
    this.baseChainGuardFacade.setRedirectUrl(window.location.href)
    this.router.navigate(['/login']);
    return false; 
  }
}
